import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { ArticleRestrictedContent as ArticleRestrictedContentBase } from "./ArticleRestrictedContent";

export type * from "./ArticleRestrictedContent";
export * from "./ArticleRestrictedContentHeader/ArticleRestrictedContentHeader";
export const ArticleRestrictedContent = withLoyaltyStore(ArticleRestrictedContentBase, "ArticleRestrictedContent");
